import { styled } from '@mui/material';

// FTDS plan status pill ("Draft" / "Complete") shown next to the Plan Overview and Plan Execution headers.
export const StatusChip = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '28px',
    minWidth: '80px',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: '100px',
    border: `1px solid ${theme.palette.semantic.int.disabled2}`,
    backgroundColor: theme.palette.semantic.int.disabled1,
    color: theme.palette.semantic.text.default,
    fontFamily: '"TT Commons Pro"',
    fontSize: '14px',
    lineHeight: '19px',
    fontWeight: 400,
    whiteSpace: 'nowrap'
}));
